import { Component, OnInit, Input} from '@angular/core';

// env
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-title-page',
  templateUrl: './title-page.component.html',
  styles: [
  ]
})
export class TitlePageComponent implements OnInit {
  
  @Input() dataTitle;
  @Input() link;
  apiAsset = environment.API_ASSETS;

  constructor() { }

  ngOnInit(): void {
  }

}
